@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.linkshare

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.web.models.linkshare.SharedLocationType

class ShareDestinationDto(
    val lat: Double,
    val lng: Double,
    val address: String?,
    val name: String?,
    val addressDetails: String?,
)

class CreateShareResponseDto(
    val shareToken: String,
    val lat: Double,
    val lng: Double,
    val url: String,
)

class OpenShareResponseDto(
    val linkShareLogId: KmmLong,
    val shareToken: String,
    val destination: ShareDestinationDto,
    @Suppress("NON_EXPORTABLE_TYPE") val sharedLocationType: DtoName<SharedLocationType>,
    val sharedByPassengerId: KmmLong,
)

class LinkShareLogDto(
    val id: KmmLong,
    val shareToken: String,
    val sharedByPassengerId: KmmLong,
    val sharedByPassengerName: String?,
    val openedByPassengerId: KmmLong?,
    val openedByPassengerName: String?,
    @Suppress("NON_EXPORTABLE_TYPE") val sharedLocationType: DtoName<SharedLocationType>,
    val favoritePointId: KmmLong?,
    val sharedLat: Double,
    val sharedLng: Double,
    val sharedAddress: String?,
    val sharedName: String?,
    val sharedOn: KmmLong,
    val openedOn: KmmLong?,
    val rideCreated: Boolean,
    val rideId: KmmLong?,
    val rideFinalStatus: String?,
    val rideCreatedOn: KmmLong?,
    val rideFinalizedOn: KmmLong?,
    val sharedByOs: String?,
    val sharedByOsVersion: String?,
    val sharedByWebVersion: String?,
    val openedByOs: String?,
    val openedByOsVersion: String?,
    val openedByWebVersion: String?,
    val isSelfOpen: Boolean,
    val openerRewardSent: Boolean,
    val sharerRewardSent: Boolean,
    val rideCompleterRewardSent: Boolean,
    val rewardsDisabled: Boolean,
)

class LinkShareRewardSettingDto(
    val id: KmmLong?,
    val name: String,
    val description: String?,
    val isActive: Boolean,
    val uniqueUsersOnly: Boolean,
    val expiresOn: KmmLong?,
    val bonusAmount: Double,
    val zoneId: Int?,
    val maxBeneficiaries: Int?,
    val perLinkLimit: Int?,
    val actualBeneficiariesCount: Int,
)

class TopLinkDto(
    val shareToken: String,
    val sharedByPassengerId: KmmLong,
    val sharedByPassengerName: String?,
    val sharedName: String?,
    val sharedAddress: String?,
    val sharedLat: Double,
    val sharedLng: Double,
    val sharedOn: KmmLong,
    val clicks: Int,
    val ridesCompleted: Int,
    val rewardsDisabled: Boolean,
)
